// extracted by mini-css-extract-plugin
module.exports = {"Plpgrid":"Plpgrid_Plpgrid__w2QId"};